module.exports = __webpack_public_path__ + "static/img/img1.e3d989a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scenariusze/img/img1.png
// module id = 3j4f
// module chunks = 0